import React, { useContext, useState } from "react";
import { Form, Button, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import Email from "./../inputs/Email";
import ModalWithEmail from "../modals/ModalWithEmail";
import Password from "./../inputs/Password";
import { BasicContext } from "../../App";
import { validateEmail } from "../../commonData";
import { postMethod } from "../../requests";

const LoginForm = (props) => {
    const { blockForm, onBlockForm, onLogin } = props;
    const { t } = useTranslation();
    const [login, setLogin] = useState({ username: "", password: "" });
    const [inputType, setInputType] = useState("password");
    const { setAlerts, checkServerData } = useContext(BasicContext);
    const [resetPasswordModal, setResetPasswordModal] = useState(false);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (!login.username.replace(/\s+/, "")) {
            $("#loginFormEmail").addClass("is-invalid");
            errors.push(t("error.emptyEmail"));
        } else if (!validateEmail(login.username)) {
            $("#loginFormEmail").addClass("is-invalid");
            errors.push(t("error.invalidEmail"));
        }

        if (login.password.length === 0) {
            $("#loginFormPassword").addClass("is-invalid");
            errors.push(t("error.emptyPassword"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            onBlockForm(true);
            setAlerts([{ variant: "info", message: t("info.logging") }]);
            setTimeout(() => {
                onLogin({
                    username: login.username,
                    password: login.password,
                });
            }, 250);
        }
    };

    const resetPassword = async (data) => {
        const res = await postMethod("/reset-password", { email: data.username });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 3000 }]);
            setResetPasswordModal(false);
        } else onBlockForm(false);
    };

    return (
        <Col>
            <Form className="px-4" onSubmit={checkValidation}>
                <Email
                    id="loginFormEmail"
                    onChange={(e) => setLogin({ ...login, username: e.target.value })}
                    onClick={() => setInputType("password")}
                    blockForm={blockForm}
                    value={login.username}
                />
                <Form.Group className="mb-3" controlID="loginFormPassword">
                    <Password
                        value={login.password}
                        onChange={(e) => setLogin({ ...login, password: e.target.value })}
                        autoComplete={"current-password"}
                        disabled={blockForm}
                        controlID={"loginFormPassword"}
                        btnID="showPass"
                        label={t("password")}
                        onBtnClick={() => setInputType(inputType === "password" ? "text" : "password")}
                        inputType={inputType}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="loginFormBtn">
                    <Button variant="primary" className="mt-2 px-4 w-100" type="submit" disabled={blockForm}>
                        {t("loginForm.loginBtn")}
                    </Button>
                </Form.Group>
            </Form>

            <p className="text-center">
                <Button variant="link" className="mb-4" onClick={() => setResetPasswordModal(true)}>
                    {t("loginForm.forgotPass")}
                </Button>
            </p>

            {resetPasswordModal ? (
                <ModalWithEmail
                    show={resetPasswordModal}
                    onProceed={(data) => {
                        onBlockForm(true);
                        resetPassword(data);
                    }}
                    onClose={() => setResetPasswordModal(false)}
                    translate={"resetPasswordModal"}
                    blockForm={blockForm}
                />
            ) : null}
        </Col>
    );
};

export default LoginForm;
